import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CandidateRatingFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CandidateRatingFilter'
import CandidateStatusFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CandidateStatusFilter'
import CollegeNameFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/CollegeNameFilter'
import GenderFilter from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Partials/GenderFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Users/Partials/UsersFilter/Styles/style'
import React, { useState } from 'react'
const ExStudentFilter = ({
  appliedCandidatesListTrue,
  searchValue,
  setSearchValue,
  candidateRating,
  setCandidateRating,
  candidateStatus,
  setCandidateStatus,
  gender,
  setGender,
  instituteSearch,
  setInstituteSearch,
  degreeListData,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  institutesList,
  campusIds,
  setCampusIds,
  candidateFilterData,
  setCandidateFilterData,
  viewRoleDetails,
  singleRoleData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const submitFilter = () => {
    setIsMenuOpen(false)
    setCandidateFilterData({
      rating: candidateRating || '',
      status: candidateStatus[0] || '',
      degreeDepartment: checkedIds || [],
      degreekeys: checkedKeys,
      collegeName: campusIds[0] || '',
      gender: gender[0] || '',
    })
  }

  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setCandidateRating(candidateFilterData?.rating)
      setCandidateStatus([candidateFilterData?.status])
      setCheckedIds(candidateFilterData?.degreeDepartment)
      setCheckedKeys(candidateFilterData?.degreekeys)
      setCampusIds([candidateFilterData?.collegeName])
      setGender([candidateFilterData?.gender])
    }
  }
  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        items={[
          {
            label: 'Candidate Rating',
            key: '1',
            hidden: !singleRoleData?.isRankingActive,
            children: (
              <CandidateRatingFilter
                candidateRating={candidateRating}
                setCandidateRating={setCandidateRating}
              />
            ),
          },
          {
            label: 'Candidate Status',
            key: '2',
            children: (
              <CandidateStatusFilter
                candidateStatus={candidateStatus}
                setCandidateStatus={setCandidateStatus}
              />
            ),
          },
          !viewRoleDetails &&
            institutesList && {
              label: 'College Name',
              key: '4',
              children: (
                <CollegeNameFilter
                  institutesList={institutesList}
                  instituteSearch={instituteSearch}
                  setInstituteSearch={setInstituteSearch}
                  campusIds={campusIds}
                  setCampusIds={setCampusIds}
                />
              ),
            },
          {
            label: 'Gender',
            key: '5',
            children: <GenderFilter gender={gender} setGender={setGender} />,
          },
        ].filter(item => !item?.hidden)}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )
  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={
        appliedCandidatesListTrue?.count < 10
          ? appliedCandidatesListTrue?.count
          : appliedCandidatesListTrue?.result?.length +
            appliedCandidatesListTrue?.page * 10
      }
      totalCount={appliedCandidatesListTrue?.count}
      onOpenChange={onCancelFilter}
    />
  )
}

export default ExStudentFilter
